import apiClient from "./axios"

// Get all vehicle fuel uses with optional filtering
export const getVehicleFuelUses = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-fuel-uses", { params })
  return data
}

// Get a specific vehicle fuel use by ID
export const getVehicleFuelUse = async id => {
  const { data } = await apiClient.get(`/vehicle-fuel-uses/${id}`)
  return data
}

// Create a new vehicle fuel use
export const createVehicleFuelUse = async useData => {
  const { data } = await apiClient.post("/vehicle-fuel-uses", useData)
  return data
}

// Update an existing vehicle fuel use
export const editVehicleFuelUse = async ({ id, ...useData }) => {
  const { data } = await apiClient.patch(`/vehicle-fuel-uses/${id}`, useData)
  return data
}

// Delete a vehicle fuel use (soft delete)
export const deleteVehicleFuelUse = async id => {
  const { data } = await apiClient.delete(`/vehicle-fuel-uses/${id}`)
  return data
}

// Get all vehicle fuel uses without pagination
export const getAllVehicleFuelUses = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-fuel-uses", {
    params: { ...params, all: true },
  })
  return data
}

// Search vehicle fuel uses by vehicle, remarks, or user
export const searchVehicleFuelUses = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/vehicle-fuel-uses", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// Get trashed vehicle fuel uses
export const getTrashedVehicleFuelUses = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-fuel-uses/trashed", { params })
  return data
}

// Restore a trashed vehicle fuel use
export const restoreVehicleFuelUse = async id => {
  const { data } = await apiClient.post(`/vehicle-fuel-uses/${id}/restore`)
  return data
}
